import { useEffect } from "react";
import { useLocation } from "wouter";

export default function RegisterRedirect() {
  const [, navigate] = useLocation();
  useEffect(() => {
    navigate("/auth?tab=register", { replace: true });
  }, [navigate]);
  return null;
}